<template>
  <div class="echarts-tool-root">
    <div class="echarts-body">
      <btnTools v-if="showTools"  :echartsTitle="echartsTitle" :echarts-data="echartsData" @change="change($event)"></btnTools>
      <div :id="echartTagId" class="echart"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import tools from './Tools/tools'
import './css/echart_tools.scss'
import shine from './theme/shine'
import btnTools from '@/components/EchartTools/Tools/btnTools'
export default {
  name: 'Core',
  components: {
    btnTools
  },
  data () {
    return {
      echartTagId: '',
      mainEcharts: {},
      debug: true,
      defaultOption: {
        title: {
          text: '',
          subtext: '',
          x: 'center'
        },
        grid: {
          bottom: 80
        },
        dataZoom: [{
          type: 'inside',
          show: true
        },
        {
          type: 'slider',
          show: true
        }],
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [],
          type: 'line'
        }]
      }
    }
  },
  computed: {
    /**
     * 标题处理
     * */
    e_title () {
      let defaultTitile = {
        text: '',
        subtext: '',
        x: 'center'
      }
      if (typeof this.echartsTitle === 'string') {
        defaultTitile.text = this.echartsTitle
      } else if (this.echartsTitle instanceof Array) {
        if (this.echartsTitle.length === 0) {
          return { title: defaultTitile }
        }
        if (this.echartsTitle.length > 0) {
          defaultTitile.text = this.echartsTitle[0]
        }
        if (this.echartsTitle.length > 1) {
          defaultTitile.subtext = this.echartsTitle[1]
        }
      } else if (this.echartsTitle instanceof Object) {
        defaultTitile = tools.merge(defaultTitile, this.echartsTitle)
      }
      return  { title: defaultTitile }
    },
    /**
     * 计算dataZoom的值
     * @returns {{show: boolean}|*}
     */
    e_zoom () {
      let that = this
      if (that.zoom instanceof Object) {
        let zoom = tools.deepCopy(that.zoom)
        zoom.show = true
        return { dataZoom: zoom }
      } else if (typeof this.zoom === 'boolean') {
        if (that.zoom) {
          return {
            dataZoom: {
              show: true
            }
          }
        }
      }
      return {
        dataZoom: {
          show: false
        }
      }
    },
    echarts_option () {
      let option = {}
      // 合并标题
      option = tools.merge(this.defaultOption, this.e_title)
      // 合并缩放
      option = tools.merge(option, this.e_zoom)
      // 合并数据
      option = tools.merge(option, this.e_data)
      return option
    },
    e_data () {
      if (this.echartsData){
        return this.analysisEchartsData(this.echartsData)
      }else{
        return {}
      }
    }
  },
  props: {
    showTools:{ //显示工具栏
      type:Boolean,
      default:true
    },
    echartsTitle: { // 标题
      type: [String, Array, Object],
      deep: true,
      default () {
        return {
          title: '',
          subtext: '',
          x: 'center'
        }
      }
    },
    zoom: {
      type: [Object, Boolean],
      deep: true,
      default () {
        return false
      }
    },
    echartsData: {
      type: [Object],
      deep: true,
      default () {
        return {
          yAxisName: '',
          xAxisName: [],
          yAxisDataType: 'date',
          xNmae:'',
          yName:'',
          data: []
        }
      }
    },
    echartsType: {
      type: String,
      default: 'line'
    },
    sizeType: {
      type: String,
      default: 'full' // simplify mini
    },
    echartsSmooth: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.echartTagId = 'echart' + new Date().getTime()
    this.$emit('onCreated', this) // onCreate 事件
  },
  watch: {
    echartsTitle (newVal) {
      this.setEchartsOption()
    },
    zoom () {
      this.setEchartsOption()
    },
    echartsData: {
      handler: function () {
        this.setEchartsOption()
      },
      deep: true
    },
    echartsType () {
      this.setEchartsOption()
    },
    echartsSmooth () {
      this.setEchartsOption()
    }
  },
  mounted () {
    this.$emit('onMounted', this) // onMounted 事件
    echarts.registerTheme('shine', shine)
    this.mainEcharts = echarts.init(document.getElementById(this.echartTagId), 'shine')
    this.setEchartsOption()
  },
  methods: {
    //工具栏
    change(val){
            this.echartsType = val
    },
    setEchartsOption () {
      let option = tools.deepCopy(this.echarts_option)
      this.$emit('onLoadOption', option, this)
      if (this.mainEcharts) {
        let option = this.echarts_option
        option = this.sizeTypeVerify(option)
        this.mainEcharts.setOption(option)
      }
      this.$emit('onLoadOptionAfter', this)
    },
    analysisEchartsData: function (data) {
      let that = this
      if (typeof data !== 'object') {
        throw '非Object类型值,无法做为数据被处理'
      }
      if (data instanceof Array) {
        throw '数组数据也无法做为被处理数据'
      }
      let option = {}
      if (this.echartsType === 'pie') { // 饼状图
        let series = {
          type: this.echartsType,
          data: [...data.data],
          itemStyle: {
            borderWidth: 3,
            borderColor: '#333'
          }
        }
        option = {
          series: series
        }
        let names = []
        for (let i = 0; i < data.data.length; i++) {
          names.push(data.data[i].name)
        }
        option = tools.merge(option, {
          legend: {
            top: 20,
            bottom: 20,
            left: 'auto',
            right: 20,
            orient: 'vertical',
            data: names,
            type: 'scroll'
          }
        })
      } else { // 非饼状图
        if (!(data.yName instanceof Array)) {
          data.yName = []
        }
        let yKey = data.yAxisName
        let xKey = data.xAxisName

        if (tools.isNullOrEmpty(xKey)) {
          throw '错误的xAxisName'
        }
        if (!(yKey instanceof Array)) {
          throw '错误的yAxisName'
        }

        let yValuesList = new Array(yKey.length)
        let xValueList = []

        for (let i = 0; i < yValuesList.length; i++) {
          yValuesList[i] = []
        }
        for (let i = 0; i < data.data.length; i++) {
          xValueList[i] = data.data[i][xKey]
          for (let j = 0; j < yKey.length; j++) {
            yValuesList[j].push(data.data[i][yKey[j]])
          }
        }
        let series = []

        for (let i = 0; i < yValuesList.length; i++) {
          series[i] = {
            name: data.yName[i] || '',
            data: yValuesList[i],
            type: this.echartsType,
            smooth: this.echartsSmooth
          }
          
        }
        option = {
          xAxis: {
            name:this.echartsData.xName,
            type: 'category',
            boundaryGap : that.echartsType === 'bar',
            data: xValueList
          },
          yAxis: {
            name:this.echartsData.yName,
            type: 'value'
          },
          series: series
        }
        if (data.yName.length > 0) {
          option = tools.merge(option, {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            legend: {
              top: 20,
              bottom: 20,
              left: 'auto',
              right:200,
              orient: 'horizontal',
              data: [...data.yName],
              type: 'scroll'
            }
          })
        }
      }
      return option
    },
    /**
     * 大小验证
     * @param option
     */
    sizeTypeVerify (option) {
      let optResult = {}
      if (this.sizeType === 'full') {
        optResult = {
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
              restore: { show: true },
              saveAsImage: { show: true }
            }
          }
        }
      } else if (this.sizeType === 'simplify') {
        optResult = {
          zoom: {
            show: false
          },
          toolbox: {
            show: false
          }
        }
      } else if (this.sizeType === 'mini') {
        let pieOption = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          title: { show: false },
          grid: { show: true, top: 0, left: 0, right: 0, bottom: 0 },
          dataZoom: { show: false },
          legend: { show: false }
        }
        optResult = tools.merge(optResult, pieOption)
      } else {

      }

      if (this.echartsType === 'pie') {
        let pieOption = {
          grid: { show: false },
          xAxis: { show: false },
          yAxis: { show: false },
          dataZoom: { show: false }
        }
        optResult = tools.merge(optResult, pieOption)
      }

      optResult = tools.merge(option, optResult)
      return optResult
    }
  }
}
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/EchartTools/index.vue"
}
</vue-filename-injector>
